import { takeLatest, put } from "redux-saga/effects";
import { PRODUCTS_FETCH } from "../constants/actionTypes";
import { call, select } from "typed-redux-saga";
import { isUserAuthenticated } from "../selectors/user";
import { FetchProductsType } from "../types/product";
import url from "../api";
import { ActionType } from "../types";
import {
  doFetchProductsDone,
  doFetchProductsStart,
  doListProducts,
} from "../actions";
import { makeApiCall } from "./general";

export default function* productSaga(): Generator {
  yield takeLatest(PRODUCTS_FETCH, doFetchProducts);
}

export function* doFetchProducts({
  payload,
}: ActionType<FetchProductsType>): Generator {
  const token = yield* select(isUserAuthenticated);
  if (token) {
    yield put(doListProducts());
  }
  // const products = yield select(menuItemProductsSelector);
  const products = [] as any[];
  if (!products || products.length === 0 || payload?.forceUpdate) {
    const { menuItems } = url;
    yield put(doFetchProductsStart());
    const data = yield* call(makeApiCall, menuItems, null, {
      headers: {
        "ALBAIK-Auth-Token": token,
      },
    }) as any;
    const error = data.error || data.errors;
    if (data && data.length > 0 && !error) {
      yield put(doFetchProductsDone(data));
    } else {
      yield put(doFetchProductsDone([]));
    }
  }
}
